exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".moneyCellWrapper-275d4{display:flex;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.moneyCell-2659e{overflow:hidden}", ""]);

// Exports
exports.locals = {
	"moneyCellWrapper": "moneyCellWrapper-275d4",
	"moneyCell": "moneyCell-2659e"
};